import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "app-footer__content" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"app-footer__contact headline\"><strong class=\"footer-headline\"> Veranstalter: Stadtwerke Castrop-Rauxel GmbH in Kooperation mit der Wirtschaftsförderung Castrop-Rauxel </strong></div><div class=\"app-footer__contact stadtwerk\"><div class=\"app-footer__title\"> Stadtwerke Castrop-Rauxel GmbH </div><div class=\"icon-row\"><div><i class=\"fas fa-fw fa-location-dot\"></i></div><div> Lönsstraße 12, 44575 Castrop-Rauxel </div></div><div class=\"icon-row\"><div><i class=\"fas fa-fw fa-phone-alt\"></i></div><div><a href=\"tel:+492305947711\" target=\"_blank\">02305 947711</a></div></div><div class=\"icon-row\"><div><i class=\"fas fa-fw fa-globe\"></i></div><div><a href=\"https://www.swcas.de\" target=\"_blank\">www.swcas.de</a></div></div></div><div class=\"app-footer__contact wirtschaft\"><div class=\"app-footer__title\"> Wirtschaft &amp; Marketing Castrop-Rauxel GmbH </div><div class=\"icon-row\"><div><i class=\"fas fa-fw fa-location-dot\"></i></div><div> Europaplatz 14, 44575 Castrop-Rauxel </div></div><div class=\"icon-row\"><div><i class=\"fas fa-fw fa-phone-alt\"></i></div><div><a href=\"tel:+4923051062306\" target=\"_blank\">02305 1062306</a></div></div><div class=\"icon-row\"><div><i class=\"fas fa-fw fa-globe\"></i></div><div><a href=\"https://www.castrop-rauxel.de/wirtschaft\" target=\"_blank\">www.castrop-rauxel.de/wirtschaft</a></div></div></div>", 3)
const _hoisted_6 = { class: "app-footer__contact logo-headline" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", { class: "footer-headline" }, " Mit freundlicher Unterstütztung von: ", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "app-footer__contact logo" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-12 col-md-auto text-start" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "d-none d-md-block col-md" }, null, -1)
const _hoisted_17 = { class: "col-12 col-md-auto text-end" }
const _hoisted_18 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IoRouterLink = _resolveComponent("IoRouterLink")!

  return (_openBlock(), _createElementBlock("footer", {
    class: _normalizeClass({ 'pd-btn': _ctx.hasKlimaheldSection })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_6, [
          (_ctx.footerLogo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.footerLogo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("img", {
                  class: "header__logo",
                  src: `${_ctx.footerLogo}`
                }, null, 8, _hoisted_12)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("nav", null, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuLeft, (menuItem) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: menuItem.url
                }, [
                  _createVNode(_component_IoRouterLink, {
                    "link-url": menuItem.url,
                    "link-target": menuItem.target,
                    "link-title": menuItem.titleAttr
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        innerHTML: menuItem.title
                      }, null, 8, _hoisted_15)
                    ]),
                    _: 2
                  }, 1032, ["link-url", "link-target", "link-title"])
                ]))
              }), 128))
            ])
          ])
        ]),
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("nav", null, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuRight, (menuItem) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: menuItem.url
                }, [
                  _createVNode(_component_IoRouterLink, {
                    "link-url": menuItem.url,
                    "link-target": menuItem.target,
                    "link-title": menuItem.titleAttr
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        innerHTML: menuItem.title
                      }, null, 8, _hoisted_18)
                    ]),
                    _: 2
                  }, 1032, ["link-url", "link-target", "link-title"])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ], 2))
}